


import './lib.js'
import './box-height.js'
import './lazyload.js'
import './form-validation.js'
import './business-form.js'
import './lightbox.js'
import './accessible-bundle.js'
import './c2c-gtag.js'
import './toc.js'
import './scroll-top.js'

window.dom = {
	header : document.getElementById('top_fix'),
	crumbs : document.querySelector('.crumb_strip'),
	adminbar : document.getElementById('wpadminbar'),
	wrapper : document.getElementById('wrapper')
};

/* ===================================================== HEADER SCRIPTS =========================================== */
function Handle_Top(el){
	var self = this;
	this.elem = (el) ? el : 'wrapper';
	this.wrapper = document.getElementById('wrapper');
	this.top_fix = document.getElementById('top_fix');
	this.htmlTag = document.querySelector('html');
	this.htmlMar = function(){return parseInt(window.getComputedStyle(self.htmlTag, null).getPropertyValue('margin-top'))};
	this.internal_header = document.querySelector('.title_strip');
	this.is_home = (document.body.className.indexOf('home') > -1);
}
	Handle_Top.prototype.sticky_header = function(){
		//if(viewport().width > 1000){
			if(window.pageYOffset > dom.header.offsetHeight){
				if(document.body.className.indexOf(' sticky_header') === -1){
					document.body.className += " sticky_header";
				}
			} else {
				document.body.className = document.body.className.replace(" sticky_header","");
			}
		//}
	};
	Handle_Top.prototype.wrapper_pad = function(){
		var self = this;
		function recourse(){
			var adminHeight = dom.adminbar ? dom.adminbar.offsetHeight : 0;
			var top_fix_height = top_fix.offsetHeight;
			self.top_fix.style.top = self.htmlMar() + "px";
			self.wrapper.style.paddingTop = top_fix_height   + "px";
			
			setTimeout(recourse,20);
		}
		recourse();
	};
	Handle_Top.prototype.a11y_btn_pos = function(){
		function recourse(){
			var btns = document.querySelectorAll('.iAccessibility-menu-button,.iAccessibility-menu');
			if(btns.length){
				[].forEach.call(btns,function(btn){
					var adminHeight = dom.adminbar ? dom.adminbar.offsetHeight : 0;
					btn.style.top = dom.header.offsetHeight + adminHeight -1 + 'px'; 
				});
			}
			setTimeout(recourse,30);
		}
		recourse();
	};
	

var handle_top = new Handle_Top();
handle_top.wrapper_pad();
handle_top.sticky_header();
window.addEventListener('load',handle_top.sticky_header);
window.addEventListener('scroll',handle_top.sticky_header);
handle_top.a11y_btn_pos();

function Mobile_Menu(args){
	var it = this;
	this.holder = document.querySelector(args.holder);
	this.btn = document.querySelector(args.btn);
	this.panel = document.createElement('div');
	this.ul = "";
	this.extras = document.querySelectorAll(args.additional_html_classes.join(','));
	this.panel_foot = document.createElement('div');
	this.panelId = "mobile_menu_" + new Date().getTime();
	this.panelClass = "mobile_menu";
	this.big = true;
	this.small = true;
	this.panel_height = 0;

	/*[1] Build the mobile menu */

	this.methods_for_menu_construction = {
		sub_menus : function(){
			var lis = document.querySelectorAll('.mobile_menu li , #main_menu li ');
			[].forEach.call(lis,function(li){
				if(li.getElementsByTagName('ul')[0]){
					it.methods_for_sub_menus.print_sub_btn(li);
				}
			});
		},
		build : function(){
			it.panel.id = it.panelId;
			it.panel.className = it.panelClass;
			it.panel.innerHTML = it.holder.innerHTML;
			it.panel.appendChild(it.panel_foot);
			it.panel_foot.className = "mobile_menu_bottom";
			it.ul = it.panel.querySelector('ul');
			document.body.appendChild(it.panel);
		},
		destroy : function(){
			var existing = document.getElementById(it.panelId);
			if(existing) existing.parentNode.removeChild(existing);
		},
		decide : function(){
			/*decide on which screen width to build the menu 
			 and on which screen width to remove it*/
			 
			if(lib.viewport().width <= (args.mobile_view || 1024)){
				if(it.small){
					this.build();
					it.big = true;it.small = false;
					this.sub_menus();
				}
			} else {
				if(it.big){
					this.destroy();
					it.big = false;it.small = true;
				}
			}
			
		}
	};
	this.create_menu_panel = function(){
		it.methods_for_menu_construction.decide();
		window.addEventListener('resize',function(){it.methods_for_menu_construction.decide();});
		
	};

	/*[2] Functionality of the open menu button */

	this.methods_for_menu_openner = {
		adminbar : document.getElementById('wpadminbar'),
		top_fix : document.getElementById('top_fix'),
		panel_dim : function(){
			var top = (this.adminbar) ? this.adminbar.offsetHeight : 0;
			top += (this.top_fix) ? this.top_fix.offsetHeight : 0;
			it.panel.style.top = top + "px";
			it.panel.style.maxHeight = lib.viewport().height - top + "px";
		},
		open : function(btn){
			this.panel_dim();
			it.panel_height = it.ul.offsetHeight + it.panel_foot.offsetHeight;
			it.panel.style.height = it.panel_height + "px";
			it.ul.style.height = "calc(100% - " + it.panel_foot.offsetHeight + "px)";
			window.addEventListener('resize',function(){
				if(btn.className.indexOf('_on_') > -1){
					this.panel_dim();
					//it.panel.style.height = it.ul.offsetHeight + "px";
				}
			}.bind(this));
			
			it.panel.className += " open";
			dom.wrapper.className += " darken_screen";
		},
		close : function(){
			it.panel.className = it.panel.className.replace(' open','');
			it.panel_height = 0;
			it.panel.style.height = "";
			it.ul.style.height = "";
			dom.wrapper.className = dom.wrapper.className.replace(' darken_screen','');
		}
	};
	this.methods_for_menu_openner.panel_dim();
	this.main_btn_click = function(){
		
		it.btn.addEventListener('click',function(){
			if(this.className.indexOf('_on_') === -1){
				it.methods_for_menu_openner.open(this);
				this.className += " _on_";
			} else {
				it.methods_for_menu_openner.close();
				var active_footer_btn = it.panel.querySelector('.mobiel_menu_bottom_show._on_');
				if(active_footer_btn) active_footer_btn.click();
				this.className = this.className.replace(' _on_','');
			}
		})

	};

	/* [3] Sub menu */

	this.methods_for_sub_menus = {
		print_sub_btn : function(el){
			var ul = el.getElementsByTagName('ul')[0],
				sub_btn = document.createElement('button');
			sub_btn.className = "open_sub on";
			el.appendChild(sub_btn);
			var height;
			sub_btn.addEventListener('click',function(){

				if(this.className.indexOf(' on') > -1){

					ul.style.height = "auto";
					height = ul.clientHeight;
					ul.removeAttribute('style');
					jQuery(ul).animate({height:height},200,function(){
						ul.style.height = "auto";
					});
					it.panel_height += height;
					it.panel.style.height = it.panel_height + "px";

					this.className = this.className.replace(' on','');
				} else {
					
					it.panel_height -= ul.offsetHeight;
					
					jQuery(ul).animate({height:0},200);
					it.panel.style.height = it.panel_height + "px";
					
					this.className += " on";
				}
			});
			var a = el.querySelector('a');
			
			if ( !a ) return;
			var frag = a.href.split('#');

			if ( !a.href || frag[1] != undefined && !(frag[1].length) ){
				
				a.addEventListener('click',function(e){
					e.preventDefault();
					sub_btn.click();
				});
			}
		}
	};

	/* [4] Additional HTML in the bottom of the menu (search , lang , accesibility, and social links) */

	this.additional_html_selectors = [];
	this.footer_children = [];
	this.methods_for_additional_content = {

		
		
	};
	this.additional_content = function(){
		var appendFrom = [].map.call(this.extras,function(e){return e.parentNode}),
		appendTo = [].map.call(this.extras,function(e){var n = document.createElement('div');n.className = 'mobile_menu_extra'; return n;}),
		self = this,
		boolD = true,
		boolM = true;
		function make(){
			
			if(lib.viewport().width < args.mobile_view){
				if(boolM){
					appendTo.forEach(function(e,i){
						appendFrom[i].style.display = 'none';
						e.appendChild(self.extras[i]);
						self.panel_foot.insertBefore(e,self.panel_foot.firstChild);
					});
				} boolM = false;boolD = true;
			} else {
				if(boolD){
					appendFrom.forEach(function(e,i){
						appendFrom[i].style.display = '';
						e.appendChild(self.extras[i]);

					});
				} boolM = true; boolD = false;
			}
			
		}
		make();
		window.addEventListener('resize',make);
		
	}
	/* Finally, run all first-level methods! */
	this.init = (function(){
		for(var k in it){
			if(it.hasOwnProperty(k) && typeof it[k] === "function"){
				it[k]();
			}
		}

	}.bind(this))();
}
var main_menu = new Mobile_Menu({
	holder : "#main_menu",
	btn : "#button_clicker",
	open_list : '.to_open',
	mobile_view : 1000,
	additional_html_classes : [
		 

		'.top_lang_container',
		//'.top_mobile_phone',
		'.top_search_container',
		'.top_social_container'				
	]
});



	/* |_ TOP CONTROLS */

(function top_controls(){
	var top_controllers = document.querySelectorAll('.top_control');
	
	if(!top_controllers.length) return;
	var content_class = '.top_control_content'
	var Methods = function() {
		this.allow_top = true;
		this.show = false;
		this.panel_arrow = function(){
			var html = 
			'<div class="top_control_top_stroke">'+
				'<div class="tdb tc_stroke_1"></div>'+
				'<div class="tdb tc_arrow_h">'+
					'<svg class="show_selected_control_arrow" preserveAspectRatio="none" viewBox="0 0 100 100">'+
						'<polyline points="0,100 50,0 100,100"></polyline>'+
					'</svg>'+	
				'</div>'+
				'<div class="tdb tc_stroke_2"></div>'+			
			'</div>';
			return html;
		};
		this.close_others = function(btn){
			var contents = document.querySelectorAll('.top_control_content');
			var btns = document.querySelectorAll('.tc_btn');
			[].forEach.call(contents,function(c){
				c.style.display = "";
			});
			[].forEach.call(btns,function(_btn){
				if(_btn === btn) return;
				_btn.className = _btn.className.replace(' on_','');
			});
		};
		this.show_panel = function(btn,content){
			this.close_others(btn);
			if(btn.className.indexOf('on_') === -1){
				content.style.display = "block";
				btn.className += " on_";
			} else {
				content.style.display = "";
				btn.className = btn.className.replace(' on_','');
			}
			if(this.allow_top){
				var top = document.createElement('div');
				top.innerHTML = this.panel_arrow();
				content.insertBefore(top,content.childNodes[0]);
				this.allow_top = false;
			}
		};
		
	};
	[].forEach.call(top_controllers,function(tc){
		
			var btn = tc.querySelector('.tc_btn');
		
			var methods = new Methods();
			
			btn.addEventListener('click',function(){
				var content = tc.querySelector(content_class);
				if(content) {
					methods.show_panel(this,content);
				}
			});
		
		/* open iAccesibility panel */
		if(btn.className.indexOf('tc_b_accessibility') > -1){
			
			tc.addEventListener('click',function(){
				var a11y_btn = document.querySelector('.iAccessibility-menu-button');
				var iAccessibilityMenu = document.querySelector('.iAccessibility-menu');
				if(a11y_btn) a11y_btn.click();

				if(!iAccessibilityMenu.querySelector('.internally_close_acc_menu')){
					var internal_btn = document.createElement('button');
					internal_btn.className = 'internally_close_acc_menu';
					internal_btn.innerHTML = 'X';
					internal_btn.onclick = function(){if(a11y_btn) a11y_btn.click();};
					console.log(internal_btn);
					iAccessibilityMenu.insertBefore(internal_btn,iAccessibilityMenu.firstChild);
				}
			});

		}
		/* remove social controls if empty */
		if(tc.className.indexOf('tc_b_social') > -1){
					

			var h = document.querySelector('.top_social_container');
			
			if(!h) return;
			if(!h.children.length){
				 h.parentNode.parentNode.removeChild(h.parentNode);
			}
		}
		
		
	});
	
	
})();

function style_wpml(){
	var lang_holder = document.getElementById('lang_sel_list');
	
	if(!lang_holder) return;
	var html_lang = document.querySelector('html').lang.slice(0,2);
	
	var langs_list = lang_holder.querySelectorAll('li');
	[].forEach.call(langs_list,function(el){
		if(el.className.indexOf(html_lang) > -1){
			el.style.display = "none";
		}
	});
	if(lang_holder.querySelector('ul').children.length <= 1){
		var lang_btns = document.querySelectorAll('.tc_b_lang');
		[].forEach.call(lang_btns,function(el){
			el.style.display = "none";
			if(el.parentNode.className.indexOf('top_control') > -1){
				el.parentNode.style.display = "none";
			}
		});
	}
	
}
style_wpml();
/* ==================================================== HOME PAGE SCRIPTS =============================================== */



/* =================================================== FLEXIBLE SCRIPTS ========================================= */


//Friefox
var FF = !(window.mozInnerScreenX == null);
if(FF) {

	jQuery('.arrow_l.ha').addClass('ff')
}

/* ajax script helpers */

function loadStyle(src){
	var first_css = document.head.querySelector('link[rel="stylesheet"]');
	var link = document.createElement('link');
	link.rel = "stylesheet";
	link.href = template_dir + '/assets/js/css/'+ src +'.css';
	
	document.head.insertBefore(link,first_css);
}
function gets_scss_vars(data){
	var vars = data.split('$');
	vars = vars.filter(function(e){
		return e.indexOf(':') > -1;
	});
	var o = {};
	vars = vars.forEach(function(e){
		var prop = '$'+ e.slice(0, e.indexOf(':')).trim();
		var value = e.slice(e.indexOf(':') + 1, e.length).trim().replace(';','');
		o[prop] = value;
	});
	return o;
	
};

/* =================================================== SCRIPT AJAX LOADING ================================= */
!function($, window, document, _undefined){
$(document).ready(function(){

	var scssVars;

	/*accesibility bundle*/
	/* $.ajax({
		url: template_dir + '/assets/js/accessible-bundle.js',
		dataType: "script",
		cache : true,
		success: function(){
		}
	}); */
	$.ajax({
		url: template_dir + '/assets/css/_vars.scss',
		dataType: "text",
		cache : true,
		success: function(data){
			scssVars = gets_scss_vars(data);
			var cat_lists = document.querySelectorAll('.content_boxes');
			if(!cat_lists.length) return;
			[].forEach.call(cat_lists,function(item){
				
        var boxFour = item.className.indexOf('boxes_four') > -1;
				var viewports = [];
				var by = [];
				if(boxFour){
					viewports = [Infinity,parseInt(scssVars.$box4_fold),parseInt(scssVars.$box_4fold_min)];
					by = [4,2,1];
				} else {
					viewports = [Infinity,parseInt(scssVars.$box3_fold),parseInt(scssVars.$box_3fold_min)];
					by = [3,2,1];
					
				}
				align_height({
					selector : item.querySelectorAll('.box_title'),
					viewports :viewports,
					by : by,
					callback : function(e,els){
						[].forEach.call(els,function(el){
							var parent =  $(el).parents('.content_boxes');
							if(parent.hasClass('show_hidden_text') || parent.parent().hasClass('show_hidden_text')) return; 
							var $bf_boxin = $(el).parents('.bf_boxin');
							var a = $bf_boxin.find('.show_on_hover');
              $bf_boxin.css({'padding-bottom': '32.5%'});
              el.style.height = $bf_boxin.css('padding-bottom');

							if(!a[0]) return;
							var el = a[0].querySelector('.box_des_zero_height');
							if(!el)return;
							a.on('mouseenter',function(){
                el.style.height = el.firstChild.offsetHeight + 'px';
							});
							a.on('mouseleave',function(){
                el.style.height = '0px';
							});
						});
					}
				});
			});
			
		}
	});

	

	

	$('.more-text').on('click', function() {
		$(this).toggleClass('open');
		$(this).prev('.full-text').slideToggle();
	});

});

/**
* Smooth anchor jump
*/ 
$('a[href*="#"]:not([href="#"])').click(function(){
	if(location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if(target.length){
			$('html,body').stop(true, true).animate({
				scrollTop: target.offset().top - $('#top_fix').outerHeight()
			}, 500);
			return false;
		}
	}
});


}(jQuery, this, document);

/*
 * Home Infographics
 */ 
window.addEventListener('load', function(){
	if(!document.querySelector('body').classList.contains('home')){
		return;
	}
	
	const infographics = document.querySelectorAll('.home_part.infographic');
	if(infographics){
		infographics.forEach(function(info_section){
			
			const items = info_section.querySelectorAll('.item_value');
			
			items.forEach(function(item){
				
				if(item.dataset.hasOwnProperty('endval')){
					const the_value = item.querySelector('.the_value');
					setInterval(function(){
						let cur_value = Number(the_value.dataset.curval);
						const end_val = Number(item.dataset.endval); 
						if(end_val <= cur_value){
							return;
						}
						else {
							const addition = ((end_val-cur_value)>Math.floor(end_val/10)) ? Math.floor(end_val/10) : Math.floor((end_val-cur_value)/10)+1;
							const new_value = cur_value+=addition;
							the_value.setAttribute('data-curval', new_value);
							the_value.innerHTML = parseFloat(new_value).toLocaleString('en');
						}
					}, 60);
				}
				
			});
			
		});
		
	}
	
	
});


// WEBPACK FOOTER //
// ./assets/js/main.js